import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL + process.env.REACT_APP_API_VERSION;

const http = axios.create({ baseURL: `${baseURL}/` });

let expiredPasswordRedirectScheduled = false;
http.interceptors.response.use(
  (response) => response,
  (error) => {
    const data = error?.response?.data;
    if (
      error?.response?.status === 401 &&
      data?.Details === "ExpiredPassword" &&
      !expiredPasswordRedirectScheduled &&
      window.location.pathname !== "/forgot-password"
    ) {
      expiredPasswordRedirectScheduled = true;
      setTimeout(() => {
        window.location.href = "/forgot-password";
      }, 1000);
    }
    return Promise.reject(error);
  }
);

function getAuthHeader() {
  const accessToken = localStorage.getItem("hema-token");
  let authHeader = { "Content-Type": "application/json" };
  if (accessToken) {
    authHeader = { Authorization: `Bearer ${accessToken}` };
  }
  return authHeader;
}

function get(url, headers = {}, params = {}, signal = null) {
  return http.get(url, {
    params,
    signal,
    headers: { ...getAuthHeader(), ...headers },
  });
}

function post(url, data, headers = {}, params = {}) {
  return http.post(url, data, {
    ...params,
    headers: { ...getAuthHeader(), ...headers },
  });
}

function put(url, data, headers = {}) {
  return http.put(url, data, { headers: { ...getAuthHeader(), ...headers } });
}

function remove(url, data, headers = {}) {
  return http.delete(url, {
    headers: { ...getAuthHeader(), ...headers },
    data,
  });
}

export { http, get, post, put, remove };
